
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export const searchDoctoresByTerm = async (
  nombre = '', 
  fields,
  establecimiento = ''
) => {

  const defaultFields = ['primerNombre', 'primerApellido', 'identificacion'];

  const queryFields = (fields && fields.length > 0) 
    ? fields.join(',') 
    : defaultFields.join(',');
  
  const query = `
    query MyQuery(
      $search: String
    ) {
      allDoctores(search: $search) {
        status
        total
        doctor {
          id
          especialidad {
            id
            descripcion
            codEsp
          }
          idPersona {
            ${queryFields}
          }
        }
      }
    }
  `;
  const variables = { 
    search: nombre, 
    establecimiento
  }

  try {
    const response = await axios.post(rutas.axios + "api", { query, variables } );
    const { data } = response;
    return data.data.allDoctores.doctor;

  } catch (error) {
    console.error("Error fetching Doctores:", error);
  }
}



const searchDoctoresByTermSelect = async (search, establecimiento = '') => {

  const response = await searchDoctoresByTerm(search, null, establecimiento);

  const data = response.map(item => ({
    ...item,
    value: item.id,
    text: `${item.idPersona.primerApellido} ${item.idPersona.primerNombre}`,
    especialidad : item.especialidad.descripcion,
    codEsp: item.especialidad.codEsp
  }));

  return data;
}


export const doctoresService = {
  searchDoctoresByTerm,
  searchDoctoresByTermSelect
}
